
import { Component, Vue, Prop, Watch } from "vue-property-decorator"
import DownArrowSVG from '../assets/down-arrow.svg'

@Component({
  components: { DownArrowSVG }
})
export default class ScrollHintArrowsHoriz extends Vue {
  @Prop({ required: true }) scrollWrapper!: HTMLElement

  private leftArrowOpacity = 0
  private rightArrowOpacity = 1

  mounted() {
    if (!this.scrollWrapper) return

    this.scrollWrapper.addEventListener('scroll', this.onScroll)
    this.updateArrowOpacities()
  }

  destroyed() {
    if (this.scrollWrapper) {
      this.scrollWrapper.removeEventListener('scroll', this.onScroll)
    }
  }

  @Watch('scrollWrapper')
  onScrollWrapperChanged(newWrapper: HTMLElement, oldWrapper: HTMLElement) {
    if (oldWrapper) {
      oldWrapper.removeEventListener('scroll', this.onScroll)
    }

    if (newWrapper) {
      newWrapper.addEventListener('scroll', this.onScroll)
      this.updateArrowOpacities()
    }
  }

  private onScroll = () => {
    this.updateArrowOpacities()
  }

  private updateArrowOpacities() {
    if (!this.scrollWrapper) return

    const scrollLeft = this.scrollWrapper.scrollLeft
    const scrollWidth = this.scrollWrapper.scrollWidth
    const clientWidth = this.scrollWrapper.clientWidth
    const scrollRight = scrollWidth - scrollLeft - clientWidth

    // Left arrow: fade in as you scroll right from start
    if (scrollLeft < 16) {
      this.leftArrowOpacity = 0
    } else {
      this.leftArrowOpacity = 1
    }

    // Right arrow: fade out as you approach end
    if (scrollRight < 16) {
      this.rightArrowOpacity = 0
    } else {
      this.rightArrowOpacity = 1
    }
  }

  // Centre a slide by scrolling the gallery only. scrollIntoView would also
  // scroll the page (on phones it pushed the gallery top under the sticky
  // header, hiding the contact card).
  private scrollGalleryTo(slide: HTMLElement) {
    if (!this.scrollWrapper) return
    const wrapperRect = this.scrollWrapper.getBoundingClientRect()
    const slideRect = slide.getBoundingClientRect()
    const left = this.scrollWrapper.scrollLeft + (slideRect.left - wrapperRect.left)
      - (this.scrollWrapper.clientWidth - slideRect.width) / 2
    this.scrollWrapper.scrollTo({ left, behavior: 'smooth' })
  }

  private scrollLeft() {
    if (!this.scrollWrapper) return

    // Find the previous image to center
    const images = this.scrollWrapper.querySelectorAll('.location-gallery__img-wrapper')
    const scrollLeft = this.scrollWrapper.scrollLeft
    const clientWidth = this.scrollWrapper.clientWidth
    const scrollCenter = scrollLeft + clientWidth / 2

    // Find the image to the left of center
    let targetImage: Element | null = null
    for (let i = images.length - 1; i >= 0; i--) {
      const img = images[i] as HTMLElement
      const imgCenter = img.offsetLeft + img.offsetWidth / 2
      if (imgCenter < scrollCenter - 10) {
        targetImage = img
        break
      }
    }

    if (targetImage) {
      this.scrollGalleryTo(targetImage as HTMLElement)
    } else {
      // If no image found, scroll to start
      this.scrollWrapper.scrollTo({ left: 0, behavior: 'smooth' })
    }
  }

  private scrollRight() {
    if (!this.scrollWrapper) return

    // console.log('scrollRight clicked!')
    // Find the next image to center
    const images = this.scrollWrapper.querySelectorAll('.location-gallery__img-wrapper')
    // console.log('Found images:', images.length)
    const scrollLeft = this.scrollWrapper.scrollLeft
    const clientWidth = this.scrollWrapper.clientWidth
    const scrollCenter = scrollLeft + clientWidth / 2

    // Log all image positions
    // for (let i = 0; i < images.length; i++) {
    //   const img = images[i] as HTMLElement
    //   console.log(`Image ${i}: offsetLeft=${img.offsetLeft}, offsetWidth=${img.offsetWidth}`)
    // }

    // Find the image to the right of center
    let targetImage: Element | null = null
    for (let i = 0; i < images.length; i++) {
      const img = images[i] as HTMLElement
      const imgCenter = img.offsetLeft + img.offsetWidth / 2
      if (imgCenter > scrollCenter + 10) {
        targetImage = img
        // console.log(`Found target image at index ${i}`)
        break
      }
    }

    if (targetImage) {
      // console.log('Scrolling to target image')
      this.scrollGalleryTo(targetImage as HTMLElement)
    } else {
      // console.log('No target found, scrolling to end')
      // If no image found, scroll to end
      this.scrollWrapper.scrollTo({ left: this.scrollWrapper.scrollWidth, behavior: 'smooth' })
    }
  }

  private onLeftHover() {
    this.$emit('hover-left')
  }

  private onRightHover() {
    this.$emit('hover-right')
  }

  private onHoverEnd() {
    this.$emit('hover-end')
  }
}
